import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=b48c07fa&scoped=true&"
import script from "./HeaderLogo.vue?vue&type=script&lang=js&"
export * from "./HeaderLogo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLogo.vue?vue&type=style&index=0&id=b48c07fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48c07fa",
  null
  
)

export default component.exports